import setTopBarMargin from '../../assets/scripts/set-topbar-margin';

export default function init() {
  const messageBanners = document.querySelectorAll('.crisis-message-notification');

  [...messageBanners].forEach((item) => {
    const btnClose = item.querySelector('[data-action="close-crisis-message"]');

    btnClose.addEventListener('click', () => {
      item.classList.add('is--hidden');
      setTopBarMargin();
    });
  });
}
